import { flattenMessages } from '../../helpers';

import enFarms from '../farms/en.json';
import esFarms from '../farms/es.json';
import ruFarms from '../farms/ru.json';
import zhFarms from '../farms/zh.json';
import enGlobal from '../global/en.json';
import esGlobal from '../global/es.json';
import ruGlobal from '../global/ru.json';
import zhGlobal from '../global/zh.json';

import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: {
    ...flattenMessages(en, 'staking'),
    ...flattenMessages(enFarms, 'farms'),
    ...flattenMessages(enGlobal, 'global'),
  },
  es: {
    ...flattenMessages(es, 'staking'),
    ...flattenMessages(esFarms, 'farms'),
    ...flattenMessages(esGlobal, 'global'),
  },
  ru: {
    ...flattenMessages(ru, 'staking'),
    ...flattenMessages(ruFarms, 'farms'),
    ...flattenMessages(ruGlobal, 'global'),
  },
  zh: {
    ...flattenMessages(zh, 'staking'),
    ...flattenMessages(zhFarms, 'farms'),
    ...flattenMessages(zhGlobal, 'global'),
  },
};
